<template>
    <toolbar-option>
        <template slot="primary">
            <toggle v-model="isChecked" @change="setChangedData(true)" />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'input-required',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Required',
            isChecked: false,
        };
    },

    watch: {
        isChecked() {
            this.selectedElements[0].requiredNew = this.isChecked;
            this.onOptionChange(this.isChecked);
        },
    },

    methods: {
        onSelectedElement() {
            this.isChecked = !!this.selectedElements[0].required;
        },
    },
};
</script>
